export default "__VITE_ASSET__Drk9XPcu__"